var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAttachmentLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3025 14.25C60.1912 14.25 57.2074 15.486 55.0073 17.686L22.9034 49.7899C19.3924 53.3009 17.4199 58.0629 17.4199 63.0282C17.4199 67.9935 19.3924 72.7555 22.9034 76.2665C26.4144 79.7775 31.1764 81.75 36.1417 81.75C41.107 81.75 45.869 79.7775 49.38 76.2665L81.4839 44.1626C82.3626 43.2839 83.7872 43.2839 84.6659 44.1626C85.5446 45.0413 85.5446 46.4659 84.6659 47.3446L52.562 79.4485C48.2071 83.8034 42.3005 86.25 36.1417 86.25C29.9829 86.25 24.0764 83.8034 19.7214 79.4485C15.3665 75.0936 12.9199 69.187 12.9199 63.0282C12.9199 56.8694 15.3665 50.9629 19.7214 46.6079L51.8254 14.504C54.8693 11.4601 58.9978 9.75 63.3025 9.75C67.6073 9.75 71.7358 11.4601 74.7797 14.504C77.8237 17.5479 79.5337 21.6764 79.5337 25.9812C79.5337 30.286 77.8237 34.4144 74.7797 37.4584L74.7789 37.4592L42.6409 69.5623C40.9079 71.2952 38.5575 72.2688 36.1068 72.2688C33.656 72.2688 31.3056 71.2952 29.5727 69.5623C27.8397 67.8294 26.8662 65.479 26.8662 63.0282C26.8662 60.5775 27.8397 58.2271 29.5727 56.4941L29.5736 56.4932L59.2322 26.8695C60.1114 25.9914 61.536 25.9922 62.4142 26.8714C63.2923 27.7506 63.2915 29.1752 62.4123 30.0534L32.7547 59.6761C31.8656 60.5651 31.3662 61.7709 31.3662 63.0282C31.3662 64.2855 31.8656 65.4913 32.7547 66.3803C33.6437 67.2694 34.8495 67.7688 36.1068 67.7688C37.3641 67.7688 38.5698 67.2694 39.4589 66.3803L39.4597 66.3795L71.5977 34.2764C71.598 34.2761 71.5983 34.2758 71.5986 34.2755C73.7981 32.0756 75.0337 29.0921 75.0337 25.9812C75.0337 22.8699 73.7978 19.886 71.5977 17.686C69.3977 15.486 66.4138 14.25 63.3025 14.25Z",
    fill: "url(#paint0_linear_601_7291)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_601_7291",
    x1: 85.3249,
    y1: 86.25,
    x2: 12.9199,
    y2: 86.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACAAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAttachmentLined);
export default __webpack_public_path__ + "static/media/ic_attachment_lined.b62830bfa85d14681cd491cc789772d3.svg";
export { ForwardRef as ReactComponent };